module.exports = __webpack_public_path__ + "img/banner1.c16185b6.jpg";